module.exports = __webpack_public_path__ + "static/media/life-overview-banner-desktop.b44e0962.jpg";